function RemoveIcon({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
    >
      <mask
        id="mask0_16452_3927"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_16452_3927)">
        <path d="M5.5 12.75V11.25H18.5V12.75H5.5Z" fill="#1C1B1F" />
      </g>
    </svg>
  );
}

export default RemoveIcon;
